// src/Sketch.js
import React, { useEffect, useRef } from 'react';
import P5 from 'react-p5';
import { getVisualAsteroids, sortLargestFirst, VISUAL_DEFAULTS } from './utils/visualAsteroids';

export default function Sketch({ asteroids, outlineColor, bgColor }) {
    const p5Ref = useRef(null);

    const setup = (p5, parent) => {
        p5.createCanvas(VISUAL_DEFAULTS.width, VISUAL_DEFAULTS.height).parent(parent);
        p5.noLoop();
        p5Ref.current = p5;
    };

    const draw = p5 => {
        p5.background(`#${bgColor}`);

        const horizonY = p5.height - VISUAL_DEFAULTS.horizonHeight;
        const earthRadius = p5.width * 3;
        p5.noStroke();
        p5.fill('#11788A');
        p5.circle(p5.width / 2, horizonY + earthRadius, earthRadius * 2);

        const visualAsteroids = getVisualAsteroids(asteroids, {
            width: p5.width,
            height: p5.height,
        });
        const sorted = sortLargestFirst(visualAsteroids);

        sorted.forEach(a => {
            const diameter = a.visualDiameter;
            const yPos = a.centerY;
            const xPos = p5.width / 2;

            if (outlineColor === 'white' || outlineColor === 'black') {
                p5.stroke(outlineColor);
                p5.strokeWeight(1.5);
            } else {
                p5.noStroke();
            }

            p5.fill(a.color);
            p5.circle(xPos, yPos, diameter);
        });
    };

    useEffect(() => {
        if (p5Ref.current) {
            p5Ref.current.clear();
            p5Ref.current.redraw();
        }
    }, [asteroids, outlineColor, bgColor]);

    return <P5 setup={setup} draw={draw} />;
}
